import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields, saveWorkingProjectSessionByField } from '@/store/slices/project';
import {
  selectIsSingleSession,
  selectOriginatingTemplateName,
  selectWorkingProjectImage,
  selectWorkingProjectRegistrationSettings,
  selectWorkingSession,
} from '@/store/slices/project/selectors';
import ProjectImageCarousel from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/project-image-carousel';
import ProjectImage from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/project-image';
import { TemplateNames } from '@/types/template-layouts.types';
import ProjectImageFooterContent from '../edit-project-image/project-image-footer-content';

const EditSessionImage = () => {
  const session = useAppSelector(selectWorkingSession);
  const originatingTemplateName = useAppSelector(selectOriginatingTemplateName);
  const workingProjectImage = useAppSelector(selectWorkingProjectImage);
  const regSettings = useAppSelector(selectWorkingProjectRegistrationSettings);
  const isSingleSession = useAppSelector(selectIsSingleSession);
  const dispatch = useAppDispatch();

  const onUpload = async (key: string, url: string | null) => {
    if (!session) return;

    switch (key) {
      case 'projectImage': {
        dispatch(saveWorkingProjectByFields({ event_image: url || undefined }));

        if (isSingleSession) {
          dispatch(
            saveWorkingProjectSessionByField({
              uuid: session.uuid,
              image: url,
            })
          );
        }
        return;
      }
      case 'sessionOrBannerImage': {
        dispatch(
          saveWorkingProjectSessionByField({
            uuid: session.uuid,
            pre_broadcast_thumbnail: url,
          })
        );
        return;
      }
      case 'registrationImage': {
        dispatch(
          saveWorkingProjectByFields({
            registration_settings: regSettings
              ? {
                  ...regSettings,
                  image: url ?? undefined,
                }
              : undefined,
          })
        );
        return;
      }
    }
  };

  if (!isSingleSession) {
    return (
      <ProjectImage
        img={session?.pre_broadcast_thumbnail}
        height="220px"
        width="392px"
        FooterContent={
          !originatingTemplateName || originatingTemplateName === TemplateNames.Limelight
            ? null
            : () => <ProjectImageFooterContent label={originatingTemplateName} />
        }
        onUpload={async (url: string) => {
          if (!session) return;
          dispatch(
            saveWorkingProjectSessionByField({
              uuid: session.uuid,
              image: url,
              pre_broadcast_thumbnail: url,
            })
          );
        }}
        onDelete={() => {
          if (!session) return;
          dispatch(
            saveWorkingProjectSessionByField({
              uuid: session.uuid,
              image: null,
              pre_broadcast_thumbnail: null,
            })
          );
        }}
      />
    );
  }

  return (
    <ProjectImageCarousel
      onUpload={onUpload}
      onDelete={(key: string) => onUpload(key, null)}
      images={{
        projectImage: workingProjectImage,
        registrationImage: regSettings?.image,
        sessionOrBannerImage: session?.pre_broadcast_thumbnail,
      }}
    />
  );
};

export default EditSessionImage;
